import styled from 'styled-components';
import { Box, Text } from '@bigcommerce/big-design';
import { useOrderStatusMap } from '../../../../context/OrderStatuses';
import { getStatusBackground } from '../../orderStatusColors';

const StyledOrderStatusColumn = styled(Box)`
	background-color: ${({ status }) => getStatusBackground(status)};
	border-radius: 2px;
	width: max-content;
`;

export default function OrderStatusColumn({ status }) {
	const orderStatuses = useOrderStatusMap();

	if (!orderStatuses.size) return <Text>Loading</Text>;

	return (
		<StyledOrderStatusColumn status={status} paddingHorizontal="small">
			<Text color="white" margin="none">
				{orderStatuses.get(status)}
			</Text>
		</StyledOrderStatusColumn>
	);
}
